/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './summary.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from './summary-admin/summary-admin.component.ngfactory';
import * as i3 from '../../../../../../../app/common/services/Report.service';
import * as i4 from '@angular/http';
import * as i5 from '@angular/router';
import * as i6 from '../../../../../../../app/common/services/ExportCustom.service';
import * as i7 from '../../../../../../../app/pages/admin/icontact/reportv2/summary/summary-admin/summary-admin.component';
import * as i8 from 'ngx-toastr';
import * as i9 from 'ngx-bootstrap/modal/bs-modal.service';
import * as i10 from './summary-agent/summary-agent.component.ngfactory';
import * as i11 from '../../../../../../../app/common/services/Field.service';
import * as i12 from '../../../../../../../app/pages/admin/icontact/reportv2/summary/summary-agent/summary-agent.component';
import * as i13 from '@angular/common';
import * as i14 from '../../../../../../../app/pages/admin/icontact/reportv2/summary/summary.component';
const styles_SummaryComponent:any[] = [i0.styles];
export const RenderType_SummaryComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_SummaryComponent,data:{}});
function View_SummaryComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'report-summary-admin',
      ([] as any[]),(null as any),(null as any),(null as any),i2.View_SummaryAdminComponent_0,
      i2.RenderType_SummaryAdminComponent)),i1.ɵprd(512,(null as any),i3.ReportService,
      i3.ReportService,[i4.Http,i5.Router]),i1.ɵprd(512,(null as any),i6.ExportCustomService,
      i6.ExportCustomService,([] as any[])),i1.ɵdid(3,7061504,(null as any),0,i7.SummaryAdminComponent,
      [i1.ChangeDetectorRef,i8.ToastrService,i9.BsModalService,i3.ReportService,i6.ExportCustomService],
      (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,3,0);
  },(null as any));
}
function View_SummaryComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'report-summary-agent',
      ([] as any[]),(null as any),(null as any),(null as any),i10.View_SummaryAgentComponent_0,
      i10.RenderType_SummaryAgentComponent)),i1.ɵprd(512,(null as any),i3.ReportService,
      i3.ReportService,[i4.Http,i5.Router]),i1.ɵprd(512,(null as any),i6.ExportCustomService,
      i6.ExportCustomService,([] as any[])),i1.ɵprd(512,(null as any),i11.FieldService,
      i11.FieldService,[i4.Http,i5.Router]),i1.ɵdid(4,7061504,(null as any),0,i12.SummaryAgentComponent,
      [i1.ChangeDetectorRef,i8.ToastrService,i9.BsModalService,i3.ReportService,i6.ExportCustomService,
          i11.FieldService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,4,0);
  },(null as any));
}
export function View_SummaryComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_SummaryComponent_1)),i1.ɵdid(1,16384,(null as any),0,i13.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
      ['\n'])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_SummaryComponent_2)),i1.ɵdid(4,16384,(null as any),0,i13.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
      ['`\n']))],(_ck,_v) => {
    var _co:i14.SummaryComponent = _v.component;
    const currVal_0:any = (_co.user.role !== _co.Roles.Agent);
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = (_co.user.role == _co.Roles.Agent);
    _ck(_v,4,0,currVal_1);
  },(null as any));
}
export function View_SummaryComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'report-summary',
      ([] as any[]),(null as any),(null as any),(null as any),View_SummaryComponent_0,
      RenderType_SummaryComponent)),i1.ɵprd(512,(null as any),i3.ReportService,i3.ReportService,
      [i4.Http,i5.Router]),i1.ɵprd(512,(null as any),i6.ExportCustomService,i6.ExportCustomService,
      ([] as any[])),i1.ɵdid(3,7061504,(null as any),0,i14.SummaryComponent,[i1.ChangeDetectorRef,
      i8.ToastrService,i9.BsModalService,i3.ReportService,i6.ExportCustomService],
      (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,3,0);
  },(null as any));
}
export const SummaryComponentNgFactory:i1.ComponentFactory<i14.SummaryComponent> = i1.ɵccf('report-summary',
    i14.SummaryComponent,View_SummaryComponent_Host_0,{},{onChangeTab:'onChangeTab'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3F1YW5ob2FuZy96ZW5pZnkvcmVwb3MvY2xpZW50LWZpbmFsL3NyYy9hcHAvcGFnZXMvYWRtaW4vaWNvbnRhY3QvcmVwb3J0djIvc3VtbWFyeS9zdW1tYXJ5LmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9xdWFuaG9hbmcvemVuaWZ5L3JlcG9zL2NsaWVudC1maW5hbC9zcmMvYXBwL3BhZ2VzL2FkbWluL2ljb250YWN0L3JlcG9ydHYyL3N1bW1hcnkvc3VtbWFyeS5jb21wb25lbnQudHMiLCJuZzovLy9Vc2Vycy9xdWFuaG9hbmcvemVuaWZ5L3JlcG9zL2NsaWVudC1maW5hbC9zcmMvYXBwL3BhZ2VzL2FkbWluL2ljb250YWN0L3JlcG9ydHYyL3N1bW1hcnkvc3VtbWFyeS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL1VzZXJzL3F1YW5ob2FuZy96ZW5pZnkvcmVwb3MvY2xpZW50LWZpbmFsL3NyYy9hcHAvcGFnZXMvYWRtaW4vaWNvbnRhY3QvcmVwb3J0djIvc3VtbWFyeS9zdW1tYXJ5LmNvbXBvbmVudC50cy5TdW1tYXJ5Q29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHJlcG9ydC1zdW1tYXJ5LWFkbWluICpuZ0lmPVwidXNlci5yb2xlICE9PSBSb2xlcy5BZ2VudFwiPjwvcmVwb3J0LXN1bW1hcnktYWRtaW4+XG48cmVwb3J0LXN1bW1hcnktYWdlbnQgKm5nSWY9XCJ1c2VyLnJvbGUgPT0gUm9sZXMuQWdlbnRcIj48L3JlcG9ydC1zdW1tYXJ5LWFnZW50PmBcbiIsIjxyZXBvcnQtc3VtbWFyeT48L3JlcG9ydC1zdW1tYXJ5PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO3lDQUFBO3VCQUFBOzZCQUFBLHNCQUFBO01BQUE7TUFBQTtJQUFBOzs7O29CQUNBO01BQUE7MENBQUE7dUJBQUE7NkJBQUE7dUJBQUEsNEJBQUE7TUFBQTswQkFBQTtJQUFBOzs7O29CQURBO01BQUEsaUNBQUE7b0JBQUEsbUNBQStFO01BQUEsU0FDL0U7TUFBQSxpQ0FBQTtvQkFBQSxtQ0FBOEU7TUFBQTs7SUFEeEQ7SUFBdEIsV0FBc0IsU0FBdEI7SUFDc0I7SUFBdEIsV0FBc0IsU0FBdEI7Ozs7b0JDREE7TUFBQTtpQ0FBQTtNQUFBO01BQUEsc0JBQUE7Z0ZBQUE7TUFBQTtJQUFBOzs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/pages/admin/icontact/reportv2/summary/summary.component.ngfactory.ts